import { render, staticRenderFns } from "./SavedProposal.vue?vue&type=template&id=388c7762&scoped=true&"
import script from "./SavedProposal.vue?vue&type=script&lang=ts&"
export * from "./SavedProposal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c7762",
  null
  
)

export default component.exports